
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import InputText from "../../shared/input/new/InputText"
import { AdminAracEkleOptions } from "../../../utils/adminAracEkleOptions"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputNewAracTypeSelect from "../../shared/input/new/InputNewAracTypeSelect"
import { addSaleVehicle } from "../../../features/ilanlar/ilanlarSlice"
import InputNumberWithSuffix from "../../shared/input/new/InputNumberWithSuffix"
import DocItem from "../../shared/doc/DocItem"
import {validateFileExceptPdf} from "../../../helper/docs/validateFileExceptPdf"
import ImageUploader from "../../docs/ImageUploader"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding-top: 20px;
        align-items: center;
        position: relative;
        overflow: hidden;

        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 700px;
            max-height: 700px;
            overflow: auto;

            &::-webkit-scrollbar {
            width: 0;
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
            .inputs{
                display: flex;
                flex-direction: column;
                gap: 15px;
                width: 70%;
                margin-top: 30px;
                .row{
                    width: 100%;
                }
            }
            .doc-list{
      display: flex;
      flex-direction: column;
        gap: 30px;
        width: 70%;
        padding: 20px 0;

        .doc-item{
            width: 100%;
            height: 400px;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            overflow: hidden;
            
            .doc-item-top{
                width: 100%;
                height: 50px;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);

                .action{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        span{

                            &:first-child{
                                width: 60px;
                            }
                        }


                        .delete-btn{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            /* background-color: var(--color-main); */
                            color: #fff;
                            color: var(--color-main);
                            border: 1px solid var(--color-main);
                            padding: 5px 7px;
                            border-radius: 5px;
                            cursor: pointer;
                            margin-right: 10px;
                            transition: .2s;
                            cursor: not-allowed;

                            &:hover{
                                background-color: var(--color-main);
                                color: #fff;
                            }
                        }
                    }
            }
        }

        .new-select-item{
            border-color: red;
            border-width: 2px;

            .new-select-item-top{
              background-color: #ff000040;
            }
        }
    }


        }

        
        .btn-group{
                display: flex;
                align-items: center;
                margin-top: 20px;
                justify-content: center;
                background-color: ${({theme}) => theme.mainBgColor};
                gap: 15px;
                width: 100%;
                height: 60px;
                border-top: 1px solid ${({theme}) => theme.mainBorderColor};

            }
    }

` 
const AddVehiclesForSaleModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {selectRentalCar } = useSelector(state => state.ilanlar)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    const [selectedTruckType, setSelectedTruckType] = useState(null)
    const [data, setData] = useState({
        modelYear: "",
        km: "",
        price: "",
        description: "",
    })

    const [fileList, setFileList] = useState([
        {
            selectedFile: null,
            loadedBefore: null,
            fileTypeName: "photo",
            staticValue: "Fotoğraf 1"
        },
        {
            selectedFile: null,
            loadedBefore: null,
            fileTypeName: "photo",
            staticValue: "Fotoğraf 2"
        },
        {
            selectedFile: null,
            loadedBefore: null,
            fileTypeName: "photo",
            staticValue: "Fotoğraf 3"
        },
    ])

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChange = (e) => {
        setData((prev) => ({...prev, [e.target.name]: e.target.value}))
    }

    const handleFileSelect = async (index, files) => {

        const file = await validateFileExceptPdf({file: files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png']})

        if(file){
            // Tüm kontroller başarılıysa, dosyayı fileList'e ekliyoruz
            const newUploads = [...fileList];
            newUploads[index].selectedFile = file;
            setFileList(newUploads);
        };
    }
    
    
    const handleSubmit = () => {
        const addData={
            vehicleType: selectedTruckType?.name,
            model: data?.modelYear,
            km: data?.km,
            price: data?.price,
            description: data?.description,
            advertStatus: "Yayında",
            files: fileList
        }
        dispatch(addSaleVehicle(addData))
    }

  return (
    <Container onClick={() => dispatch(showModal(null)) }>
        <div className="modal" onClick={(e)=>{e.stopPropagation(); dispatch(handleActiveSelect(null))}} >
            <PageTopTitle isDiffPage title={"Satılık Araç Ekle"}/>

            <div className="content">
                <div className="inputs">
                    <div className="row">
                        <InputNewAracTypeSelect data={selectedTruckType} setData={setSelectedTruckType} labelText={"Araç Tipi"} name={"selectedTruckType"} initialOptions={AdminAracEkleOptions} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix noneSeperator data={data?.modelYear} setData={(e) => handleChange(e)} name={"modelYear"} labelText={"Model Yılı"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix suffix={" Km"} data={data?.km} setData={(e) => handleChange(e)} name={"km"} labelText={"Km"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix suffix={" TL"} data={data?.price} setData={(e) => handleChange(e)} name={"price"} labelText={"Fiyat"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputText data={data?.description} setData={(e) => handleChange(e)} name={"description"} labelText={"Açıklama"} inputWidth={"100%"} />
                    </div>
                </div>
                <div className="doc-list">
                {
                    fileList.map((fileItem, index) => {
                        let previewSrc;
                        let isPdf;
                        if (fileItem.selectedFile) {
                            isPdf = fileItem.selectedFile.type === "application/pdf"
                            previewSrc = URL.createObjectURL(fileItem.selectedFile);

                        } else if (fileItem.loadedBefore) {
                          previewSrc = `${process.env.REACT_APP_API_IMG_URI}${fileItem.loadedBefore}`;
                        } else {
                          previewSrc = "question";
                        }

                        return (
                            <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                 <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                    {fileItem.selectedFile ? (
                                        <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                    ) : fileItem.loadedBefore ? (
                                        <p className="action">
                                            <span></span>
                                            <span>Önceden Yüklenmiş Belge - ({fileItem.fileTypeName})</span>
                                            {/* <button className="delete-btn" onClick={() => handleRemoveDoc(fileItem)}>Belgeyi Sil</button> */}
                                        </p>
                                    ) : (
                                        <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                    )}
                                </div>
                                <ImageUploader 
                                    previewSrc={previewSrc}
                                    isPdf={isPdf} 
                                    onFileSelect={(files) => handleFileSelect(index, files)} 
                                />
                            </div>
                        )
                    }) 
                }
                </div>

            </div>
                <div className="btn-group">
                    <Button width="150px" handleClick={handleSubmit} padding="10px" background="#fff" color={"#E85446"}>Ekle</Button>
                    <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
        </div>
    </Container>
  )
}

export default AddVehiclesForSaleModal